import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import request from "../../lib/requester";
import _ from "lodash";
import ReactExport from "react-export-excel";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class UpdateBudget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: new Date(),
      submittedDateTo: new Date(),
    };
  }

  componentDidMount = () => {};

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "PRGORAM NO",
          accessor: "program_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_name",
          filterable: true,
        },
        // {
        //     Header: 'BUDGET TYPE',
        //     accessor: 'budget_type'
        // },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          Cell: (row) => (
            <span>
              {row.value
                ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "0"}
            </span>
          ),
        },
        {
          Header: "",
          accessor: "program_id",
          Cell: (row) => (
            <span>
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  this.goDetail(row);
                }}
              >
                Update <i className="fas" />
              </button>
            </span>
          ),
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            default:
              columnes = row[filter.id];
          }

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    }

    return mappingStatus;
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "program-summary-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success">
            <i className="fas fa-file-excel" />
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Customer" value="customer" />
          <ExcelColumn label="Principal" value="org_name" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          {/* <ExcelColumn label="Budget Type" value="budget_type" /> */}
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Member" value="member_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/program/updatebudget/" + row.program_id);
  };

  handleSearch = () => {
    let url = "/api/traces/v1/program/list-budget";
    let param = {
      org_id: this.state.user.org_id,
      source: "infostep",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(this.state.submittedDateFrom).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(this.state.submittedDateTo).format("YYYY-MM-DD")
          : "",
    };

    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {/* <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search Program..." onChange={ this.handleSearch.bind(this) } />
                                            </div>
                                        </div> */}
                    {/* <div className="clearfix">&nbsp;</div> */}
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-md-2 mt-1">Submitted Date From: </div>
                      <div className="col-lg-2">
                        <DatePicker
                          placeholder="Submitted Date from"
                          selected={this.state.submittedDateFrom}
                          dateFormat="d-MMM-yyyy"
                          className="form-control myDatePicker"
                          popperPlacement="bottom-end"
                          onChange={this.handleSubmittedDateFrom}
                        />
                      </div>
                      <div className="col-md-2 mt-1">To: </div>
                      <div className="col-lg-2">
                        <DatePicker
                          placeholder="Submitted Date from"
                          selected={this.state.submittedDateTo}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="bottom-end"
                          onChange={this.handleSubmittedDateTo}
                        />
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary btn-block"
                        onClick={this.handleSearch.bind(this)}
                      >
                        <i class="fas fa-search"></i> Search
                      </button>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default UpdateBudget;
